// Create new file: framework/client/core/ScriptLoader.js

export class ScriptLoader {
    static loadedScripts = new Map();

    /**
     * Loads a script dynamically and returns a promise that resolves when the script is loaded.
     * Ensures that the same script is not loaded multiple times.
     * @param {string} url The URL of the script to load.
     * @returns {Promise<void>}
     */
    static load(url) {
        if (this.loadedScripts.has(url)) {
            return this.loadedScripts.get(url);
        }

        const promise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            script.async = true;

            script.onload = () => {
                console.log(`[ScriptLoader] Script loaded successfully: ${url}`);
                resolve();
            };

            script.onerror = () => {
                console.error(`[ScriptLoader] Failed to load script: ${url}`);
                this.loadedScripts.delete(url); // Allow retrying on failure
                reject(new Error(`Failed to load script: ${url}`));
            };

            document.head.appendChild(script);
        });

        this.loadedScripts.set(url, promise);
        return promise;
    }
}